import React from 'react';
import { PageLayout } from '../../components/layout/PageLayout';

export default function Webhooks() {
  return (
    <PageLayout
      title="Webhooks & System Status"
      subtitle="Automate your reporting workflows with instant, real-time transaction notifications."
      badge="INFRASTRUCTURE"
      imageSrc="/products/art_webhooks_1776905177492.png"
    >
      <div className="bg-white p-10 rounded-3xl border border-gray-100 shadow-sm mt-16">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-4 h-4 rounded-full bg-green-500 animate-pulse"></div>
          <h3 className="text-xl font-bold text-gray-900">All Systems Operational</h3>
        </div>
        <p className="text-gray-600 mb-8 max-w-2xl">
          Register HTTP endpoints to receive JSON payloads whenever critical events occur on your account. Listen for successful authorizations, failed recurring subscriptions, chargebacks, and vault updates instantly.
        </p>
        <div className="bg-gray-50 p-6 rounded-xl border border-gray-100">
          <h4 className="font-bold text-gray-900 mb-4">Supported Event Types:</h4>
          <div className="flex flex-wrap gap-2">
            {['transaction.sale', 'transaction.auth', 'subscription.charged', 'customer.created'].map(e => (
              <span key={e} className="px-3 py-1 bg-white border border-gray-200 rounded text-sm text-gray-700 font-mono">{e}</span>
            ))}
          </div>
        </div>
      </div>
    </PageLayout>
  );
}
